import { render, staticRenderFns } from "./reviewRecords.vue?vue&type=template&id=110113c8&scoped=true"
import script from "./reviewRecords.vue?vue&type=script&lang=js"
export * from "./reviewRecords.vue?vue&type=script&lang=js"
import style0 from "./reviewRecords.vue?vue&type=style&index=0&id=110113c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110113c8",
  null
  
)

export default component.exports